import { createContext, useContext, useState } from "react";

const FormContext = createContext(undefined);

export function FormProvider({ children }) {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    phoneVerified: false,
    currentEducation: "",
    educationCountry: "",
    preferredCountry: "",
    studyLevel: "",
    fieldOfStudy: "",
    testScores: {
      ielts_overall: "",
      ielts_reading: "",
      ielts_writing: "",
      ielts_speaking: "",
      ielts_listening: "",
      // toefl: "",
      // pte: "",
      // gmat: "",
      // gre: "",
      // sat: "",
      // tenth: "",
      // twelfth: "",
      // UGcgpa: "",
    }
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    hasNextPage: false,
    hasPrevPage: false,
    itemsPerPage: 9,
    totalItems: 9,
    totalPages: 1,
  });

  const updateFormData = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };
  const resetFormData = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      phoneVerified: false,
      currentEducation: "",
      educationCountry: "",
      preferredCountry: "",
      studyLevel: "",
      fieldOfStudy: "",
      testScores: {
        ielts_overall: "",
        ielts_reading: "",
        ielts_writing: "",
        ielts_speaking: "",
        ielts_listening: "",
        // toefl: "",
        // pte: "",
        // gmat: "",
        // gre: "",
        // sat: "",
        // tenth: "",
        // twelfth: "",
        // UGcgpa: "",
      },
    });
    setPagination({
      currentPage: 1,
      hasNextPage: false,
      hasPrevPage: false,
      itemsPerPage: 9,
      totalItems: 9,
      totalPages: 1,
    });
    setStep(1);
  };

  return (
    <FormContext.Provider
      value={{
        formData,
        updateFormData,
        step,
        setStep,
        pagination,
        setPagination,
        resetFormData,
      }}
    >
      {children}
    </FormContext.Provider>
  );
}

export const useForm = () => {
  const context = useContext(FormContext);
  if (!context) throw new Error("useForm must be used within FormProvider");
  return context;
};
